<script lang="tsx">
  import { defineAsyncComponent } from "vue";
  import { ProgressBar, Skeleton } from "primevue";
  const PasswordStrength = defineAsyncComponent(async () => await import("./PasswordStrength.vue"));

  export default {
    components: { Skeleton, PasswordStrength, ProgressBar },
    props: PasswordStrength.props as (typeof PasswordStrength["props"]),
  };
</script>

<template>
  <Suspense v-bind.attr="$attrs">
    <PasswordStrength v-bind.attr="$attrs" v-bind.prop="$props as any"/>

    <template #fallback>
      <div>
        <ProgressBar class="score" mode="indeterminate"><span></span></ProgressBar>
      </div>
    </template>
  </Suspense>
</template>

<style lang="less" scoped>
div {
  display: flex;
  flex-direction: column;

  // * { flex: 1 0 100%; }
}

.score {
  height: 0.5em;
}

.messages {
  overflow-wrap: break-word;
  word-break: break-word;
}
</style>
